// Loading Spinner
// ===============
import React from 'react';
import classNames from 'classnames';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const Spinner = props => /*#__PURE__*/_jsx("div", {
  className: classNames(style.Spinner, {
    [style[props.className]]: props.className
  }),
  "data-id": "spinner_index_Spinner_div"
});
export default Spinner;